// Deprecated. Import from 'metadata.js' directly instead.
export { getCountryCallingCode as default } from './metadata';
//# sourceMappingURL=getCountryCallingCode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/es6/getCountryCallingCode.js
// module id = 624
// module chunks = 2